'use client';
import { type PropsWithChildren, useEffect } from 'react';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import ReduxProvider from '@/providers/ReduxProvider';
import AppStateProvider from '@/providers/AppStateProvider';
import { theme } from '@/utils/theme';

export default function AppProviders({ children }: PropsWithChildren) {
  // NOTE: Need to wrap in useEffect otherwise `window` is undefined due to Next.js pre-rendering
  useEffect(() => {
    if (getEnv() !== NODE_ENV.PRODUCTION) window.muiTheme = theme;
  }, []);

  return (
    <ReduxProvider>
      <AppStateProvider>{children}</AppStateProvider>
    </ReduxProvider>
  );
}
